<template>
  <div>
    <TituloComponent
      icono-titulo="fas fa-file-invoice"
      texto-titulo="Impresiones y listados"
    ></TituloComponent>
    <div class="card-shadow-primary mb-3 card">
      <div class="grid-menu grid-menu-2col mt-0">
        <div class="no-gutters row">
          <div class="col-sm-6">
            <button
              class="btn-icon-vertical btn-square btn-transition btn btn-outline-success"
              @click="imprimirComprobantes = true"
            >
              <span
                class="fas fa-file-invoice-dollar btn-icon-wrapper btn-icon-lg mb-3 opacity-9"
              ></span
              >Impresión de comprobantes
            </button>
          </div>
          <div class="col-sm-6">
            <button
              @click="imprimirListadoArticulos = true"
              class="btn-icon-vertical btn-square btn-transition btn btn-outline-info"
            >
              <i
                class="fas fa-hand-holding-usd btn-icon-wrapper btn-icon-lg mb-3"
              ></i>
              Listado de precios
            </button>
          </div>
          <div class="col-sm-6">
            <button
              @click="imprimirListadoStock = true"
              class="btn-icon-vertical btn-square btn-transition btn btn-outline-alternate"
            >
              <i class="fas fa-boxes btn-icon-wrapper btn-icon-lg mb-3"></i>
              Listado de stock
            </button>
          </div>
          <div class="col-sm-6">
            <button
              @click="imprimirListadoClientes = true"
              class="btn-icon-vertical btn-square btn-transition btn btn-outline-danger"
            >
              <i class="fas fa-users btn-icon-wrapper btn-icon-lg mb-3"></i>
              Listado de clientes
            </button>
          </div>
          <div class="col-sm-6">
            <button
              @click="imprimirCuentasCorrientes = true"
              class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
            >
              <i
                class="fas fa-cash-register btn-icon-wrapper btn-icon-lg mb-3"
              ></i
              >Cuentas corrientes
            </button>
          </div>
          <div class="col-sm-6">
            <button
              @click="imprimirControlReparto = true"
              class="btn-icon-vertical btn-square btn-transition btn btn-outline-focus"
            >
              <i
                class="fas fa-truck btn-icon-wrapper btn-icon-lg mb-3 opacity-10"
              ></i
              >Control de reparto
            </button>
          </div>
          <div class="col-sm-6">
            <button
              @click="imprimirComisionVendedor = true"
              class="btn-icon-vertical btn-square btn-transition btn btn-outline-success"
            >
              <i
                class="fas fa-dollar-sign btn-icon-wrapper btn-icon-lg mb-3 opacity-10"
              ></i
              >Comisión vendedores
            </button>
          </div>
          <div class="col-sm-6">
            <button
              @click="imprimirExcelVentasPorArticulo = true"
              class="btn-icon-vertical btn-square btn-transition btn btn-outline-success"
            >
              <i
                class="fas fa-dollar-sign btn-icon-wrapper btn-icon-lg mb-3 opacity-10"
              ></i
              >Excel de ventas por articulo
            </button>
          </div>
          <div class="col-sm-6">
            <button
              @click="imprimirConsolidadoProductosReparto = true"
              class="btn-icon-vertical btn-square btn-transition btn btn-outline-warning"
            >
              <i
                class="fas fa-box btn-icon-wrapper btn-icon-lg mb-3 opacity-10"
              ></i
              >Consolidado de productos - Reparto
            </button>
          </div>
          <div class="col-sm-6"></div>
        </div>
      </div>
    </div>
    <modalImprimirComprobantes
      v-if="imprimirComprobantes"
      @cerrarImprimirComprobantes="imprimirComprobantes = false"
    ></modalImprimirComprobantes>
    <modalListadoArticulos
      v-if="imprimirListadoArticulos"
      @cerrarListadoArticulo="imprimirListadoArticulos = false"
    ></modalListadoArticulos>
    <modalListadoStock
      v-if="imprimirListadoStock"
      @cerrarListadoArticulo="imprimirListadoStock = false"
    ></modalListadoStock>
    <modalListadoClientes
      v-if="imprimirListadoClientes"
      @cerrarListadoClientes="imprimirListadoClientes = false"
    ></modalListadoClientes>
    <modalCuentasCorrientes
      v-if="imprimirCuentasCorrientes"
      @cerrarCuentasCorrientes="imprimirCuentasCorrientes = false"
    ></modalCuentasCorrientes>
    <modalControlReparto
      v-if="imprimirControlReparto"
      @cerrarControlReparto="imprimirControlReparto = false"
    ></modalControlReparto>
    <modalComisionVendedor
      v-if="imprimirComisionVendedor"
      @cerrarComisionVendedor="imprimirComisionVendedor = false"
    ></modalComisionVendedor>
    <modal-excel-ventas-por-articulo
      v-if="imprimirExcelVentasPorArticulo"
      @cerrar="imprimirExcelVentasPorArticulo = false"
    ></modal-excel-ventas-por-articulo>
    <modalConsolidadoProductosReparto
      v-if="imprimirConsolidadoProductosReparto"
      @cerrarConsolidadoProductosReparto="
        imprimirConsolidadoProductosReparto = false
      "
    ></modalConsolidadoProductosReparto>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import modalImprimirComprobantes from "@/components/views/reportes/modalImprimirComprobantes";
import modalListadoClientes from "@/components/views/reportes/modalListadoClientes";
import modalListadoArticulos from "@/components/views/reportes/modalListadoArticulos";
import modalListadoStock from "@/components/views/reportes/modalListadoStock";
import modalCuentasCorrientes from "@/components/views/reportes/modalCuentasCorrientes";
import modalControlReparto from "@/components/views/reportes/modalControlReparto";
import modalComisionVendedor from "@/components/views/reportes/modalComisionVendedor";
import ModalExcelVentasPorArticulo from "@/components/views/reportes/modalExcelVentasPorArticulo.vue";
import modalConsolidadoProductosReparto from "@/components/views/reportes/modalConsolidadoProductosReparto.vue";

export default {
  name: "reportes",
  components: {
    ModalExcelVentasPorArticulo,
    TituloComponent,
    modalImprimirComprobantes,
    modalListadoArticulos,
    modalListadoStock,
    modalListadoClientes,
    modalCuentasCorrientes,
    modalControlReparto,
    modalComisionVendedor,
    modalConsolidadoProductosReparto,
  },
  data() {
    return {
      imprimirComprobantes: false,
      imprimirCuentasCorrientes: false,
      imprimirListadoClientes: false,
      imprimirListadoArticulos: false,
      imprimirListadoStock: false,
      imprimirControlReparto: false,
      imprimirComisionVendedor: false,
      imprimirExcelVentasPorArticulo: false,
      imprimirConsolidadoProductosReparto: false,
    };
  },
};
</script>
